module.exports = __webpack_public_path__ + "static/media/image_4.61ae215b.png";